import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventEventIdScorekeepingAssignmentLayoutRoute() {
  return <ModalStack />;
}
